import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MainShared {
  constructor() {}

  postId = '';
  currentTab: number;

  private openReportBottomsheetObs = new BehaviorSubject<boolean>(false);
  openReportBottomsheetObs$ = this.openReportBottomsheetObs.asObservable();

  private secondTabPlansObs = new BehaviorSubject<boolean>(false);
  secondTabPlansObs$ = this.secondTabPlansObs.asObservable();

  private secondTabMyPlanObs = new BehaviorSubject<boolean>(false);
  secondTabMyPlanObs$ = this.secondTabMyPlanObs.asObservable();

  openReportBottomsheet(postId: string) {
    this.postId = postId;
    this.openReportBottomsheetObs.next(true);
    this.openReportBottomsheetObs.next(false);
  }

  secondTabPlans() {
    this.secondTabPlansObs.next(true);
    this.secondTabPlansObs.next(false);
  }

  secondTabMyPlan() {
    this.secondTabMyPlanObs.next(true);
    this.secondTabMyPlanObs.next(false);
  }

  getReportPostId() {
    return this.postId;
  }
}
